<template>
  <div>
    <PageBanner title="联系我们" subtitle="秉承“以诚为本、以质取信、以品生存”的宗旨，竭诚为您服务" />
    <section class="page-section">
      <div class="contact-page">
        <div class="contact-page__info">
          <ContactInfo />
          <div class="contact-page__quick">
            <div class="quick-item">
              <span class="icon">📞</span>
              <div class="desc">
                <h5>电话直接沟通</h5>
                <p>欢迎直接拨打服务电话，沟通工程需求、设备选型与非标定制细节。</p>
              </div>
            </div>
            <div class="quick-item">
              <span class="icon">🤝</span>
              <div class="desc">
                <h5>欢迎来厂考察</h5>
                <p>支持工程设备商及各大生产制造厂商预约来厂考察，实地看品质更省心。</p>
              </div>
            </div>
          </div>
        </div>
        <div class="contact-page__map-wrapper">
          <div class="contact-page__map-header">
            <span>📍 中泉环保高精度百度电子地图</span>
          </div>
          <div class="contact-page__map">
            <iframe
              :src="company.mapUrl"
              title="广东中泉环保科技有限公司百度地图"
              width="100%"
              height="100%"
              frameborder="0"
              scrolling="no"
              loading="lazy"
              tabindex="-1"
            ></iframe>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import PageBanner from '@/components/PageBanner.vue'
import ContactInfo from '@/components/ContactInfo.vue'
import { COMPANY } from '@/constants/company'

export default {
  name: 'ContactView',
  components: { PageBanner, ContactInfo },
  data () {
    return { company: COMPANY }
  }
}
</script>

<style lang="scss" scoped>
.contact-page {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;

  &__info {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }

  &__quick {
    border-top: 1px dashed var(--color-border);
    padding-top: 2rem;
    display: flex;
    flex-direction: column;
    gap: 1.25rem;

    .quick-item {
      display: flex;
      align-items: flex-start;
      gap: 1rem;
      text-align: left;

      .icon {
        font-size: 1.5rem;
        background: var(--color-primary-light);
        color: var(--color-primary);
        width: 2.75rem;
        height: 2.75rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: var(--radius-sm);
        flex-shrink: 0;
      }

      .desc {
        h5 {
          font-size: 1rem;
          font-weight: 700;
          color: var(--color-dark);
          margin-bottom: 0.25rem;
        }
        p {
          font-size: 0.85rem;
          color: var(--color-text-muted);
          margin: 0;
          line-height: 1.5;
        }
      }
    }
  }

  &__map-wrapper {
    background: #fff;
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-lg);
    border: 1px solid var(--color-border);
    overflow: hidden;
  }

  &__map-header {
    background: var(--color-bg-alt);
    padding: 0.75rem 1.25rem;
    border-bottom: 1px solid var(--color-border);
    font-size: 0.85rem;
    font-weight: 700;
    color: var(--color-dark-muted);
    text-align: left;
  }

  &__map {
    height: 24rem;

    iframe {
      display: block;
      pointer-events: none;
    }
  }
}

@media (max-width: 992px) {
  .contact-page {
    grid-template-columns: 1fr;
    gap: 3rem;
  }
}
</style>
